import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FilterService, GridDataResult, KENDO_GRID, PageChangeEvent, PagerSettings } from '@progress/kendo-angular-grid';
import { AuditLogService } from './audit-log.service';
import { Observable } from 'rxjs';
import { CompositeFilterDescriptor, FilterDescriptor, State } from '@progress/kendo-data-query';

@Component({
  selector: 'app-audit-log',
  standalone: true,
  imports: [CommonModule, FormsModule, KENDO_GRID],
  providers: [AuditLogService],
  templateUrl: './audit-log.component.html'
})
export class AuditLogComponent implements OnInit {
  public view: Observable<GridDataResult>;
  public error: boolean = false;
  public errorMessage: string = '';
  public validationMessage: string = '';

  public state: State = {
    skip: 0,
    take: 20,
  };

  public pageableSettings: PagerSettings = {
    pageSizes: [10, 20, 50, 100]
  };

  public filter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [],
  };

  constructor(public auditLogService: AuditLogService) {
    this.view = auditLogService;
    this.auditLogService.query(this.state, this.filter);
  }

  ngOnInit(): void {}

  public pageChange(state: PageChangeEvent): void {
    this.state.skip = state.skip;
    this.state.take = state.take;
    this.auditLogService.query(this.state, this.filter);
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.state.skip = 0;

    // Validate: all active string filters must be >= 3 chars
    const stringFields = ['entity', 'column', 'updatedBy', 'itemId', 'supplierId'];
    const invalid = stringFields.some(field => {
      const val = this.getFilterValue(filter, field);
      return val.length > 0 && val.length < 3;
    });

    if (invalid) {
      this.validationMessage = 'Please enter at least 3 characters to filter.';
      return;
    }

    this.validationMessage = '';
    this.auditLogService.query(this.state, this.filter);
  }

  public getFilterValue(filter: CompositeFilterDescriptor, field: string): string {
    const descriptor = this.findFieldFilter(filter, field);
    return descriptor ? String(descriptor.value ?? '') : '';
  }

  private findFieldFilter(filter: CompositeFilterDescriptor, field: string): FilterDescriptor | null {
    for (const item of filter.filters) {
      if ('filters' in item) {
        const nested = this.findFieldFilter(item, field);
        if (nested) return nested;
      } else if (item.field === field) {
        return item;
      }
    }
    return null;
  }

  private removeFieldFilter(
    filters: Array<FilterDescriptor | CompositeFilterDescriptor>,
    field: string
  ): Array<FilterDescriptor | CompositeFilterDescriptor> {
    return filters.reduce((acc, item) => {
      if ('filters' in item) {
        const nested = this.removeFieldFilter(item.filters, field);
        if (nested.length) acc.push({ logic: item.logic, filters: nested });
      } else if (item.field !== field) {
        acc.push(item);
      }
      return acc;
    }, [] as Array<FilterDescriptor | CompositeFilterDescriptor>);
  }
}